import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'pt-PT',
  months: [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro',
  ],
  monthsShort: ['jan.', 'fev.', 'mar.', 'abr.', 'mai.', 'jun.', 'jul.', 'ago.', 'set.', 'out.', 'nov.', 'dez.'],
  weekdays: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
  weekdaysMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  weekdaysShort: ['dom.', 'seg.', 'ter.', 'qua.', 'qui.', 'sex.', 'sáb.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D [de] MMMM [de] YYYY',
    'LL-D': 'MMMM [de] YYYY',
    'LL-Y': 'D [de] MMMM',
    LLL: 'D [de] MMMM [de] YYYY, HH:mm',
    'LLL-Y': 'D [de] MMMM, HH:mm',
    LLLL: 'dddd, D [de] MMMM [de] YYYY, HH:mm',
    'LLLL-Y': 'dddd D [de] MMMM, HH:mm',
    l: 'DD/MM/YYYY',
    'l-Y': 'DD/MM',
    ll: 'D-MMM-YY',
    'll-Y': 'D-MMM',
    'll-D': 'MMM-YY',
    lll: 'D [de] MMM [de] YYYY, h:mm A',
    'lll-Y': 'D [de] MMM, h:mm A',
    llll: 'ddd, D [de] MMM [de] YYYY, h:mm A',
    'llll-Y': 'ddd, D [de] MMM, h:mm A',
    'll-Y+w': 'ddd, D [de] MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D [de] MMMM [de] YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'a.m.', pm: 'p.m.', AM: 'a.m.', PM: 'p.m.' },
  past: {
    y: { one: 'há %s ano', other: 'há %s anos' },
    M: { one: 'há %s mês', other: 'há %s meses' },
    w: { one: 'há %s sem.', other: 'há %s sem.' },
    d: { one: 'há %s dia', other: 'há %s dias' },
    h: { one: 'há %s h', other: 'há %s h' },
    m: { one: 'há %s min', other: 'há %s min' },
    s: { one: 'há %s s', other: 'há %s s' },
  },
  future: {
    y: { one: 'dentro de %s ano', other: 'dentro de %s anos' },
    M: { one: 'dentro de %s mês', other: 'dentro de %s meses' },
    w: { one: 'dentro de %s sem.', other: 'dentro de %s sem.' },
    d: { one: 'dentro de %s dia', other: 'dentro de %s dias' },
    h: { one: 'dentro de %s h', other: 'dentro de %s h' },
    m: { one: 'dentro de %s min', other: 'dentro de %s min' },
    s: { one: 'dentro de %s s', other: 'dentro de %s s' },
  },
  pastLong: {
    y: { one: 'há %s ano', other: 'há %s anos' },
    M: { one: 'há %s mês', other: 'há %s meses' },
    w: { one: 'há %s semana', other: 'há %s semanas' },
    d: { one: 'há %s dia', other: 'há %s dias' },
    h: { one: 'há %s hora', other: 'há %s horas' },
    m: { one: 'há %s minuto', other: 'há %s minutos' },
    s: { one: 'há %s segundo', other: 'há %s segundos' },
  },
  futureLong: {
    y: { one: 'dentro de %s ano', other: 'dentro de %s anos' },
    M: { one: 'dentro de %s mês', other: 'dentro de %s meses' },
    w: { one: 'dentro de %s semana', other: 'dentro de %s semanas' },
    d: { one: 'dentro de %s dia', other: 'dentro de %s dias' },
    h: { one: 'dentro de %s hora', other: 'dentro de %s horas' },
    m: { one: 'dentro de %s minuto', other: 'dentro de %s minutos' },
    s: { one: 'dentro de %s segundo', other: 'dentro de %s segundos' },
  },
  abbr: {
    y: { one: '%s ano', other: '%s anos' },
    M: { one: '%s mês', other: '%s meses' },
    w: { one: '%s sem.', other: '%s sem.' },
    d: { one: '%s dia', other: '%s dias' },
    h: { one: '%s h', other: '%s h' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  full: {
    y: { one: '%s ano', other: '%s anos' },
    M: { one: '%s mês', other: '%s meses' },
    w: { one: '%s semana', other: '%s semanas' },
    d: { one: '%s dia', other: '%s dias' },
    h: { one: '%s hora', other: '%s horas' },
    m: { one: '%s minuto', other: '%s minutos' },
    s: { one: '%s segundo', other: '%s segundos' },
  },
  justNow: 'Agora mesmo',
  yesterday: 'ontem',
  today: 'hoje',
  tomorrow: 'amanhã',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D [de] MMMM [de] YYYY', end: 'D [de] MMMM [de] YYYY' },
    'yl-1': { start: 'D [de] MMMM', end: 'D [de] MMMM [de] YYYY' },
    ml: { start: 'D [de] MMMM', end: 'D [de] MMMM' },
    'ml-1': { start: 'D', end: 'D [de] MMMM [de] YYYY' },
    dl: { start: 'D', end: 'D [de] MMMM' },
    y: { start: 'D [de] MMM [de] YYYY', end: 'D [de] MMM [de] YYYY' },
    'y-1': { start: 'D [de] MMM', end: 'D [de] MMM [de] YYYY' },
    m: { start: 'D [de] MMM', end: 'D [de] MMM' },
    'm-1': { start: 'D', end: 'D [de] MMM [de] YYYY' },
    d: { start: 'D', end: 'D [de] MMM' },
    Y: { start: 'ddd, D [de] MMM [de] YYYY', end: 'ddd, D [de] MMM [de] YYYY' },
    'Y-1': { start: 'ddd, D [de] MMM', end: 'ddd, D [de] MMM [de] YYYY' },
    M: { start: 'ddd, DD/MM', end: 'ddd, DD/MM' },
    D: { start: 'ddd, DD/MM', end: 'ddd, DD/MM' },
    yt: { start: 'D [de] MMM [de] YYYY, HH:mm', end: 'D [de] MMM [de] YYYY, HH:mm' },
    mt: { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm' },
    dt: { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D [de] MMM [de] YYYY, HH:mm', end: 'D [de] MMM [de] YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D [de] MMM, HH:mm', end: 'D [de] MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'pt-PT';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}º`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'a.m.' : 'a.m.';
    } else {
      return isLowerCase ? 'p.m.' : 'p.m.';
    }
  },
};
